import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { getImg } from '../../../utils/getImg';
import { createBlock, mergeBlock, t } from '../../../utils';
import { BasicBlock } from '../../../components/BasicBlock';

export type IHero = IBlockData<
    {
        'background-color'?: string;
        'background-height'?: string;
        'background-position'?: string;
        'background-url'?: string;
        'background-width'?: string;
        'vertical-align'?: string;
        'border-radius'?: string;
        height?: string;
        mode: 'fluid-height' | 'fixed-height';
        padding?: string;
    },
    {}
>;

export const Hero = createBlock<IHero>({
    get name() {
        return t('Hero');
    },
    type: BasicType.HERO,
    create: (payload: any) => {
        const defaultData: IHero = {
            type: BasicType.HERO,
            data: {
                value: {},
            },
            attributes: {
                'background-color': '#ffffff',
                'background-position': 'center center',
                mode: 'fluid-height',
                padding: '100px 0px 100px 0px',
                'vertical-align': 'top',
                'background-url': getImg('IMAGE_31'),
                height: '470px',
                'background-height': '470px'
            },
            children: [
                {
                    type: 'text',
                    data: {
                        value: {
                            content: 'We Serve Healthy &amp; Delicious Foods',
                        },
                    },
                    attributes: {
                        padding: '10px 25px 10px 25px',
                        align: 'center',
                        color: '#ffffff',
                        'font-size': '45px',
                        'line-height': '45px',
                    },
                    children: [],
                },
                {
                    type: 'text',
                    data: {
                        value: {
                            content:
                                'A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.',
                        },
                    },
                    attributes: {
                        align: 'center',
                        'background-color': '#414141',
                        color: '#ffffff',
                        'font-weight': 'normal',
                        padding: '10px 25px 10px 25px',
                        'line-height': '1.5',
                        'vertical-align': 'middle',
                        'font-size': '14px',
                    },
                    children: [],
                },
                {
                    type: 'button',
                    data: {
                        value: {
                            content: 'Get Your Order Here!',
                        },
                    },
                    attributes: {
                        align: 'center',
                        'background-color': '#f3a333',
                        color: '#ffffff',
                        'font-size': '13px',
                        'font-weight': 'normal',
                        'border-radius': '30px',
                        padding: '10px 25px 10px 25px',
                        'inner-padding': '10px 25px 10px 25px',
                        'line-height': '120%',
                        target: '_blank',
                        'vertical-align': 'middle',
                        border: 'none',
                        'text-align': 'center',
                        href: '#',
                    },
                    children: [],
                },
            ],
        };
        return mergeBlock(defaultData, payload);
    },
    validParentType: [BasicType.PAGE, BasicType.WRAPPER],
    render(params: any) {
        return <BasicBlock params={params} tag="mj-hero" />;
    },
});
